import { render, staticRenderFns } from "./JsonSchema.vue?vue&type=template&id=7b47fe4b"
import script from "./JsonSchema.vue?vue&type=script&lang=js"
export * from "./JsonSchema.vue?vue&type=script&lang=js"
import style0 from "./JsonSchema.vue?vue&type=style&index=0&id=7b47fe4b&prod&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports